import * as Scrivito from "scrivito";

const TableRowWidget = Scrivito.provideWidgetClass("TableRowWidget", {
  attributes: {
    cells: ["widgetlist", { only: "TableCellWidget" }],
    verticalAlignment: ["enum", { values: ["top", "middle", "bottom"] }],
  },
  onlyInside: "TableRowWidget",
  extractTextAttributes: ["cells"],
});

export default TableRowWidget;
